var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { TermOptions, termOptions, } from "../../../features/unlinked-application/constants";
import AppBody from "../../../components/AppBody";
import { Button } from "@savvyinsure/react-ui";
import Header from "../../../components/Header";
import classNames from "classnames";
import { completedPage } from "../../../lib/Avo";
import { savePremiumTerm } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
var INSURED_HEADER_CONTENT = "How often are you paying for auto insurance?";
var UNINSURED_HEADER_CONTENT = "How often do you want to pay for auto insurance?";
export default function UnlinkedApplicationAutoPaymentPeriod() {
    var history = useHistory();
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (state) { return state.unlinkedApplication; }), entryAction = _a.entryAction, auto = _a.auto;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _b = useForm({
        defaultValues: {
            term: auto.term || TermOptions.Monthly,
        },
        mode: "onChange",
    }), setValue = _b.setValue, handleSubmit = _b.handleSubmit, watch = _b.watch;
    var termValue = watch("term");
    var label = entryAction === "not-insured" ? "want to pay" : "pay";
    var header = entryAction === "not-insured"
        ? UNINSURED_HEADER_CONTENT
        : INSURED_HEADER_CONTENT;
    var onSubmit = function (_a) {
        var term = _a.term;
        if (!term)
            return;
        dispatch(savePremiumTerm({ policyType: "auto", term: term }));
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: term, optionSelected: term }));
        history.push("/auto/unlinked-application/premium");
    };
    var onClose = function () {
        if (!termValue)
            return;
        dispatch(savePremiumTerm({ policyType: "auto", term: termValue }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { onClose: onClose, showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, null,
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement("div", { className: "mb-4 flex-none pt-4" },
                    React.createElement(UnlinkedApplicationForm.Header, { className: "mb-1" }, header)),
                React.createElement("form", { className: "mb-4 space-y-4", onSubmit: handleSubmit(onSubmit) },
                    React.createElement("button", { type: "button", className: classNames("block w-full rounded border border-gray-200 p-4 text-left", {
                            "border-savvy-100 bg-[#F5F8FF] font-semibold text-savvy-100": termValue === termOptions[0].value,
                        }), onClick: function () {
                            return setValue("term", termOptions[0].value, {
                                shouldValidate: true,
                            });
                        } }, "I ".concat(label, " monthly")),
                    React.createElement("button", { type: "button", className: classNames("block w-full rounded border border-gray-200 p-4 text-left", {
                            "border-savvy-100 bg-[#F5F8FF] font-semibold text-savvy-100": termValue === termOptions[1].value,
                        }), onClick: function () {
                            return setValue("term", termOptions[1].value, {
                                shouldValidate: true,
                            });
                        } }, "I ".concat(label, " every 6 months")),
                    React.createElement("button", { type: "button", className: classNames("block w-full rounded border border-gray-200 p-4 text-left", {
                            "border-savvy-100 bg-[#F5F8FF] font-semibold text-savvy-100": termValue === termOptions[2].value,
                        }), onClick: function () {
                            return setValue("term", termOptions[2].value, {
                                shouldValidate: true,
                            });
                        } }, "I ".concat(label, " every year")),
                    React.createElement(Button, null, "Continue"))))));
}
